import React from 'react'
import BookingStore from './bookingStore';
// import applicantDetailStore from './applicantDetailStore';


class RootStore {
  constructor() {
    this.bookingStore = new BookingStore(this);
  }
}


const StoresContext = React.createContext(new RootStore());

export const useStores = () => React.useContext(StoresContext);